import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// Stock variances: each van's expected stock at its next count against what
// was counted. Worked out on the tech server from the same movements Stock
// Check uses; outcomes are recorded there too.
export function useStockVariances(filters) {
  return useQuery({
    queryKey: ['stockVariances', filters],
    queryFn: async () => (await api.get('/api/van-requests/variances', { params: filters })).data,
    staleTime: 60000,
  });
}

// Record an outcome for one flagged line or several in the same count pair.
export function useRecordVarianceOutcome() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body) => (await api.post('/api/van-requests/variances/outcome', body)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stockVariances'] }),
  });
}

// Everything behind one flagged line - only fetched when the line is opened.
export function useVarianceDetail({ from, to, item }, enabled) {
  return useQuery({
    queryKey: ['stockVariances', 'detail', from, to, item],
    queryFn: async () => (await api.get('/api/van-requests/variances/detail', {
      params: { from, to, item },
    })).data,
    enabled: Boolean(enabled && from && to && item),
    staleTime: 60000,
  });
}

export function useVarianceHistory({ from, to, item }, enabled) {
  return useQuery({
    queryKey: ['stockVariances', 'history', from, to, item],
    queryFn: async () => (await api.get('/api/van-requests/variances/history', {
      params: { from, to, item },
    })).data.history,
    enabled: Boolean(enabled && from && to && item),
  });
}
